var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container2 container3"},[_c('GridLayout',[_c('ChartPanel',{attrs:{"config":_vm.config1}}),_c('ChartPanel',{attrs:{"config":_vm.config2}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }